"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHEventHandler = void 0;
class KHEvent {
    constructor(name) {
        this.name = name;
        this.callbacks = [];
    }
    registerCallback(cb) {
        this.callbacks.push(cb);
    }
    unregisterCallback(cb) {
        let idx = this.callbacks.indexOf(cb);
        if (idx < 0)
            return;
        this.callbacks.splice(idx, 1);
    }
    unregisterAll() {
        this.callbacks = [];
    }
    emitEvent(data) {
        this.callbacks.forEach(function (callback) {
            callback(data);
        });
    }
}
class KHEventHandler {
    constructor(defaultEvents = []) {
        this.events = new Map();
        for (let i = 0, n = defaultEvents.length; i < n; i++) {
            this.addEvent(defaultEvents[i]);
        }
    }
    addEvent(name) {
        this.events.set(name, new KHEvent(name));
    }
    emitEvent(name, args = null) {
        if (!this.events.has(name)) {
            console.trace("Unregistered event name: " + name);
            return;
        }
        this.events.get(name).emitEvent(args);
    }
    registerCallback(name, cb) {
        if (!this.events.has(name)) {
            console.trace("Unregistered event name: " + name);
            return;
        }
        this.events.get(name).registerCallback(cb);
    }
    unregisterCallback(name, cb) {
        if (!this.events.has(name)) {
            console.log("Unregistered event name: " + name);
        }
        this.events.get(name).unregisterCallback(cb);
    }
    unregisterAllCallbacks() {
        for (const entry of this.events.entries()) {
            entry[1].unregisterAll();
        }
    }
}
exports.KHEventHandler = KHEventHandler;
